import axios from 'axios'
import store from '../store/index'
import * as types from '../store/mutation-types'
import Router from 'vue-router'
import {
  util,
  storage
} from "@common/utils/util"
import Constant from '@/Constant'

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers.Authorization = `token ${store.state.token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    console.log('axios response >>>', response);
    if (response.data && response.data.errCode) {
      let errmsg = Constant.errorMsg[response.data.errCode] || response.data.message;
      if (response.data.errCode == "AccessPermissionDeny") {
        location.href = '/main/auth?redirect=' + location.href;
        return;
      }
    }
    // tokenCall  401 token失效，重新登录
    if (response.data && response.data.code) {
      console.log('response.data', response.data)
      if (response.data.code == 401) {
        //判断属于哪个模块登录customerService：售后登录
        let belong = storage.local.get('belong');
        let redirect = ''
        switch (belong) {
          case "customerService":
            redirect = encodeURIComponent(location.pathname + location.search)
            location.href = '/main/customerLogin?redirect=' + redirect;
            break;
          case "fitting":
            redirect = encodeURIComponent(location.pathname + location.search)
            location.href = '/fitting/role?redirect=' + redirect;
            break;
          default:
            location.href = '/main/agencyLogin?redirect=' + location.href;
            break;
        }
        return Promise.reject(response.data.message);
      }
    }

    return response;
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          store.commit(types.LOGOUT);
          location.href = '/main/auth?redirect=' + location.href;
      }
    }

    if (error.toString().indexOf('Network') > 0) {
      /* MessageBox.alert("网络异常！");*/
    }

    return Promise.reject(error)
  }
)

export default axios;



// WEBPACK FOOTER //
// ./src/service/axios.js